export default {
  bind(el, binding, vnode) {
    el.addEventListener("input", (event) => {
      let value = event.target.value
      if (value.trim() === "") {
        event.target.value = 0;
        event.target.dispatchEvent(new Event("input"));
      }
    });
  },
};